import { ApplicationConfig, importProvidersFrom, isDevMode, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HttpClient } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideServiceWorker } from '@angular/service-worker';

import { ApmErrorHandler, ApmModule, ApmService, APM } from '@elastic/apm-rum-angular';
import { apm } from '@elastic/apm-rum';
import { initApm } from '../apmInitilize';

function isLocalhost(): boolean {
  if (typeof location === 'undefined') return false;
  return location.hostname === 'localhost' || location.hostname === '127.0.0.1';
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export const provideTranslation = () => ({
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideToastr(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    importProvidersFrom(TranslateModule.forRoot(provideTranslation())),
    importProvidersFrom(ApmModule),

    // APM required providers
    { provide: APM, useValue: apm },
    { provide: ErrorHandler, useClass: ApmErrorHandler },
    { provide: APP_INITIALIZER, useFactory: initApm, deps: [ApmService], multi: true },
  ],
};